/* eslint-disable react/no-array-index-key */
import { Dispatch, FC, SetStateAction } from 'react';

import {
  SatoshiOptionEnum,
  SatoshiOptionEnumFormatted,
} from '~/modules/satoshi/enums/SatoshiOptionEnum';

import { GenericCheckOption } from '~/common/components/GenericCheckOption';

import { OptionsList } from './styles';

interface IOptionsStepProps {
  option: SatoshiOptionEnum;
  visible: boolean;
  setOption: Dispatch<SetStateAction<SatoshiOptionEnum>>;
}
export const OptionsStep: FC<IOptionsStepProps> = ({
  option: selected,
  visible = false,
  setOption,
}) => {
  return (
    <OptionsList visible={visible}>
      {Object.entries(SatoshiOptionEnumFormatted).map(
        ([option, label], index) => (
          <GenericCheckOption
            key={String(index)}
            selected={selected === option}
            onSelect={() => setOption(option as SatoshiOptionEnum)}
            label={{
              label,
            }}
          />
        )
      )}
    </OptionsList>
  );
};
